import React from 'react';
import { BrowserRouter as Router, Route, Redirect,Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { isAuthenticated } from './services/auth';
import AdminSideBar from './globals/Layout/Admin/Sidebar';
import LayoutComponent from './globals/Layout/Layout';
import ErrorServer from './globals/Layout/Error/ErrorServer';
import UpdatePassword from './components/UpdatePassword';
import Login from './components/Login/Login';
import PlanBilling from './components/PlanBilling';
import CompanyManagement from './components/CompanyManagement';
import BillingManagement from './components/BillingManagement';
import PlanManagement from './components/PlanManagement';
import SpecialitySectionManagement from './components/SpecialitySectionManagement';
import TbcUserManagement from './components/TbcUserManagement';
import LegalDocumentManagement from './components/LegalDocumentManagement';
import PayPhoneResponse from './components/PayPhoneResponse';
import PayPhoneBridge from './components/PayPhoneBridge';
import ProductPackageManagement from './components/ProductPackageManagement';
import OrganizationManagement from './components/OrganizationManagement';
import PatientManagement from './components/PatientManagement';
import DirectSalesDocumentManagement from './components/DirectSalesDocumentManagement';
import GlobalOrganizationConfiguration from './components/GlobalOrganizationConfiguration';
import { getProfile } from './store/user/thunks';

const DirectSalesDocumentRoute = connect(null, { getProfile })(DirectSalesDocumentManagement);


const ConfigRouter: React.FC = () => {
  return (

    <Router>       
      <Switch>
      <PublicRouteWrapper path='/' exact component={Login} layout={LayoutComponent} />    
       <Route path='/error-server' exact component={ErrorServer}  />  
       <PublicRouteWrapper path='/update-password/:token' exact component={UpdatePassword} layout={LayoutComponent} />  
       <PrivateRouteWrapper path='/plan-billing' exact component={PlanBilling} />  
       <PrivateRouteWrapper path='/company-management' exact component={CompanyManagement} />
       <PrivateRouteWrapper path='/billing-management' exact component={BillingManagement} />
       <PrivateRouteWrapper path='/plan-management' exact component={PlanManagement} />  
       <PrivateRouteWrapper path='/speciality-section-management' exact component={SpecialitySectionManagement} />  
       <PrivateRouteWrapper path='/tbc-user-management' exact component={TbcUserManagement} />  
       <PrivateRouteWrapper path='/legal-document-management' exact component={LegalDocumentManagement} />  
       <PrivateRouteWrapper path='/product-package-management' exact component={ProductPackageManagement} />  
       <PrivateRouteWrapper path='/organization-management' exact component={OrganizationManagement} />
       <PrivateRouteWrapper path='/patient' exact component={PatientManagement} />
       <PrivateRouteWrapper path='/patient-management' exact component={PatientManagement} />
       <PrivateRouteWrapper path='/global-configuration' exact component={GlobalOrganizationConfiguration} />
       <PrivateRouteWrapper path='/sales-document/direct' exact component={DirectSalesDocumentRoute} />
       <PrivateRouteWrapper path='/direct-sales-document' exact component={DirectSalesDocumentRoute} />
       <Route path='/payphone/bridge' exact component={PayPhoneBridge} />  
       <Route path='/payphone/response' exact component={PayPhoneResponse} />  

      </Switch> 
    </Router>

  );
};

const PublicRouteWrapper = (props: any) => {
  const { component: Component, layout: LayoutComponent, ...rest } = props;
  return (
    <Route {...rest} render={(props: any) =>
      <LayoutComponent {...props}>
        <Component {...props} />
      </LayoutComponent>
    } />
  );
}
function PrivateRouteWrapper(props: any) {
  const { component: Component, ...rest } = props;
  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated() ? (
          <AdminSideBar {...props}>
            <Component {...props} />
          </AdminSideBar>
        ) : (
          <Redirect
            to={{
              pathname: "/",
            }}
          />
        )
      }
    />
  );
}





export default ConfigRouter;
